// src/components/Header.jsx
import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <h2>Ganesh Amgain</h2>
      </div>
      <div className="header-right">
        <nav className={`nav-links ${isMenuOpen ? 'nav-open' : ''}`}>
          <a href="#hero" onClick={e => { e.preventDefault(); handleNavClick("hero"); closeMenu(); }}>Home</a>
          <a href="#qualifications" onClick={e => { e.preventDefault(); handleNavClick("qualifications"); closeMenu(); }}>Qualification</a>
          <a href="#services" onClick={e => { e.preventDefault(); handleNavClick("services"); closeMenu(); }}>Services</a>
          <a href="#research" onClick={e => { e.preventDefault(); handleNavClick("research"); closeMenu(); }}>Research</a>
          <a href="#testimonials" onClick={e => { e.preventDefault(); handleNavClick("testimonials"); closeMenu(); }}>Testimonials</a>
          <a href="#contact" onClick={e => { e.preventDefault(); handleNavClick("contact"); closeMenu(); }}>Contact</a>
        </nav>
        <button className="hamburger-menu" onClick={toggleMenu}>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
        {/*<a href="#hero">
          <div
            className="profile-img"
            style={{
              backgroundImage:
                'url("./profile.jpg")',
            }}
          />
        </a>*/}
      </div>
    </header>
  );
};

export default Header;